export const COLORS = {
  // Black
  blackPure: '#000000',
  blackBase: '#373d3f',

  // Brand
  reportBuilderGray: '#33404d',
  brandPrimary: '#ff8300',
  brandPrimarySubdued: '#FFCF9E',
  brandPrimaryBackground: '#FFECD9',
  brandSecondary: '#9cd47b',
  brandSecondarySubdued: '#CCF5B6',
  brandSecondaryBackground: '#EBF6E5',
  brandBlack: '#393a44',
  brandWhite: '#ffffff',

  // Accent
  ctaPrimary: '#0073a3',
  ctaPrimarySubdued: '#80b9d1',
  ctaPrimaryBackground: '#d9eaf1',
  ctaPrimaryBackgroundLighter: '#f2f9fc',
  ctaPrimaryBackgroundLightest: '#fcfeff',
  ctaPrimaryHover: '#005072',
  ctaPrimaryGradient: 'linear-gradient(142.45deg, #0073a3 0%, #d9eaf1 136.04%)',

  ctaBrand: '#ff8300',
  ctaBrandBackground: '#ffecd9',
  ctaBrandBackgroundLighter: '#fff8f1',
  ctaBrandBackgroundLightest: '#fffdfb',
  ctaBrandGreen: '#9CD47B',
  ctaBrandOrange: '#FF8300',
  ctaBrandGradient: 'linear-gradient(142.45deg, #ff8300 0%, #ffecd9 136.04%)',

  // Grey
  greyLightest: '#F8FBFF',
  greyLight: '#EAF0F6',
  greyBase: '#B4C3D2',
  greyDark: '#5F7892',
  greyDarkest: '#445769',
  //Repeated for grey/gray interchangability
  grayLightest: '#F8FBFF',
  grayLight: '#EAF0F6',
  grayBase: '#B4C3D2',
  grayDark: '#5F7892',
  grayDarkest: '#445769',

  // White
  whiteLight: '#fafafa',
  whiteBase: '#ffffff',
  whiteDark: '#f1f1f1',

  // Status
  success: '#219653',
  successSubdued: '#82caa1',
  successBackground: '#d6f1e2',

  warning: '#f2c94c',
  warningDark: '#BA8E23',
  warningSubdued: '#f5df9a',
  warningBackground: '#fffaeb',

  critical: '#bb1b00',
  criticalHover: '#c91d00',
  criticalSubdued: '#ee6a5f',
  criticalBackground: '#f6c8c6',

  highlight: '#368f9e',
  highlightSubdued: '#90bac3',
  highlightBackground: '#e9f8fc',

  disabledBackground: '#f2f6fa',
  disabledText: '#8c9094',

  brown: '#c4a484',

  // Charity Navigator
  cnBlue: '#355ffe',
};
